// Basic Accessibility Fixes
$(document).ready(function() {
    $('br').attr('aria-hidden','true');
    $('hr').attr('aria-hidden','true');

    // Remove empty Heading
    $('h1, h2, h3, h4, h5, h6').each(function () {
        if ($(this).text().trim() === '') {
            $(this).remove();
        }
    });
});

// color swatches warning on product page
$(document).ready(function () {
// Define the observer callback
  const observerCallback = function (mutationsList, observer) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        $(mutation.addedNodes).each(function () {
          // Check if the added node is the target UL or contains it
          if ($(this).is('ul.swatch-view.swatch-view-custom-image[role="radiogroup"]') ||
              $(this).find('ul.swatch-view.swatch-view-custom-image[role="radiogroup"]').length) {

            $('.form__width .product__form variant-swatch-king .swatches #swatch-group5450447 ul.swatch-view-image[role="radiogroup"], .form__width .product__form variant-swatch-king .swatches #swatch-group3978770 ul.swatch-view-custom-image').each(function () {
              if (!$(this).attr('aria-label')) {
                $(this).attr(
                  'aria-label',
                  'Choose a color. Product will refresh the page' 
                );
              }
            });
          }
        });
      }
    });
  };

  // Create the observer instance
  const observer = new MutationObserver(observerCallback);

  // Start observing the body for child node additions
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});



//shop the button dialog fixed
$(document).ready(function() {
  $('#shop-the-room-button').on('click', function() {
    $('.px-look-drawer-close').focus();
  });

  $('.px-look-drawer-close').on('click', function() {
    $('#shop-the-room-button').focus();
  });
});


//shop the button pop up aria-state updated
$(document).ready(function() {
  function updateAriaHidden() {
    const $drawer = $('#drawer-template--18987291869357__shop_the_room_Rm43wa');

    if ($drawer.hasClass('px-look-drawer')) {
      $drawer.attr('aria-hidden', 'true');
    }

    if ($drawer.hasClass('active')) {
      $drawer.attr('aria-hidden', 'false');
    } else {
      $drawer.attr('aria-hidden', 'true');
    }
  }

  // Run once on load
  updateAriaHidden();

  // Optionally re-run on class change
  const observer = new MutationObserver(updateAriaHidden);
  observer.observe(document.getElementById('drawer-template--18987291869357__shop_the_room_Rm43wa'), {
    attributes: true,
    attributeFilter: ['class']
  });
});

// hidden content remove after header
$(document).ready(function () {
  // Check if it's desktop view (e.g., width >= 1024px)
  if ($(window).width() >= 769) {
    $('.search-popdown').remove();
  }
});

// Price accessibility labels
$(document).ready(function() {
  function updatePriceAccessibility() {
    // Regular/Sale Price
    // NOTE: .new-price is deliberately excluded. Product grid items already render their
    // own visually-hidden price label in Liquid, so injecting another here made screen
    // readers announce "Price: Price: $790".
    $('.product__price:not(.product__price--compare)').each(function() {
      var $this = $(this);
      var label = 'Price: ';
      
      // Check if on sale (class is usually on the child span or the element itself)
      if ($this.find('.product__price--sale').length > 0 || $this.hasClass('product__price--sale')) {
        label = 'Sale Price: ';
      }

      var $labelSpan = $this.find('.visually-hidden-price-label');
      
      if ($labelSpan.length === 0) {
        $this.prepend('<span class="visually-hidden visually-hidden-price-label">' + label + '</span>');
      } else {
        // Update label if state changed (e.g. variant switch)
        if ($labelSpan.text() !== label) {
          $labelSpan.text(label);
        }
      }
    });

    // Compare/Old Price
    // .old-price excluded for the same reason — grid items already label it in Liquid.
    $('.product__price--compare').each(function() {
      if ($(this).find('.visually-hidden-price-label').length === 0) {
        $(this).prepend('<span class="visually-hidden visually-hidden-price-label">Original price: </span>');
      }
    });
  }

  // Run initially
  updatePriceAccessibility();

  // Observe for changes (AJAX loading or class changes)
  const observer = new MutationObserver(function(mutations) {
    let shouldUpdate = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || (mutation.type === 'attributes' && mutation.attributeName === 'class')) {
        shouldUpdate = true;
      }
    });
    if (shouldUpdate) {
      updatePriceAccessibility();
    }
  });

  observer.observe(document.body, { 
    childList: true, 
    subtree: true, 
    attributes: true, 
    attributeFilter: ['class'] 
  });
});

// Product tabs keyboard navigation
$(document).ready(function() {
  function initTabAccessibility() {
    $('[data-tabs-holder]').each(function() {
      const $tabsHolder = $(this);
      const $tablist = $tabsHolder.find('[role="tablist"]');
      const $tabs = $tablist.find('[role="tab"]');
      const $panels = $tabsHolder.find('[role="tabpanel"]');
      
      if ($tabs.length === 0) return;

      // Click handler for tab activation
      $tabs.off('click.a11yTabs').on('click.a11yTabs', function(e) {
        e.preventDefault();
        activateTab($(this));
      });

      // Keyboard navigation
      $tabs.off('keydown.a11yTabs').on('keydown.a11yTabs', function(e) {
        const $currentTab = $(this);
        const currentIndex = $tabs.index($currentTab);
        let $targetTab = null;

        switch(e.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            e.preventDefault();
            $targetTab = currentIndex > 0 ? $tabs.eq(currentIndex - 1) : $tabs.last();
            break;
          case 'ArrowRight':
          case 'ArrowDown':
            e.preventDefault();
            $targetTab = currentIndex < $tabs.length - 1 ? $tabs.eq(currentIndex + 1) : $tabs.first();
            break;
          case 'Home':
            e.preventDefault();
            $targetTab = $tabs.first();
            break;
          case 'End':
            e.preventDefault();
            $targetTab = $tabs.last();
            break;
          default:
            return;
        }

        if ($targetTab) {
          activateTab($targetTab);
          $targetTab.focus();
        }
      });

      // Helper function to activate a tab
      function activateTab($tab) {
        const tabIndex = $tab.data('tab');
        
        // Update all tabs in this container
        $tabs.attr({
          'aria-selected': 'false',
          'tabindex': '-1'
        }).removeClass('current');

        // Update all panels in this container - use hidden attribute for proper accessibility
        $panels.each(function() {
          $(this)
            .attr('aria-hidden', 'true')
            .attr('hidden', true)
            .removeClass('current');
        });

        // Activate selected tab
        $tab.attr({
          'aria-selected': 'true',
          'tabindex': '0'
        }).addClass('current');

        // Show selected panel - find by matching index
        const $panel = $tabsHolder.find('.tab-content-' + tabIndex);
        if ($panel.length) {
          $panel
            .attr('aria-hidden', 'false')
            .removeAttr('hidden')
            .addClass('current');
        }
      }

      // Initialize: ensure first tab is active
      const $firstTab = $tabs.first();
      const $firstPanel = $panels.first();
      
      // Set initial states
      $tabs.attr({
        'aria-selected': 'false',
        'tabindex': '-1'
      }).removeClass('current');
      
      $panels.attr('aria-hidden', 'true').attr('hidden', true).removeClass('current');
      
      $firstTab.attr({
        'aria-selected': 'true',
        'tabindex': '0'
      }).addClass('current');
      
      $firstPanel.attr('aria-hidden', 'false').removeAttr('hidden').addClass('current');
    });
  }

  // Run on load
  initTabAccessibility();

  // Re-run when sections are loaded dynamically
  $(document).on('shopify:section:load', function() {
    initTabAccessibility();
  });
});

// Variant swatch aria-checked correction (Swatch King / StarApps app extension)
//
// The app drives aria-checked from two independent code paths that don't stay in sync:
//   1. its arrow-key roving-focus handler sets aria-checked on the FOCUSED swatch
//   2. its selection handler sets aria-checked on the SELECTED swatch
// Arrow-navigating therefore leaves a stale aria-checked="true" on the previously
// selected swatch while the real selection loses its state — screen readers then
// announce the old swatch as selected and the current one as a plain radio.
//
// The app does track true selection separately, via the .swatch-selected class
// (it reads that class elsewhere to resolve swatch-url / orig-value), so we use it as
// the source of truth and re-assert aria-checked to match. Focus position stays owned
// by the app via tabindex and .swatch-keyboard-focus — we never touch those.
//
// Purely additive and defensive: no-ops when no radiogroup is present, so it costs
// nothing if the app is removed, and it can be deleted outright once the vendor fixes it.
$(document).ready(function () {
  function syncSwatchChecked(root) {
    var groups = (root || document).querySelectorAll('[role="radiogroup"]');

    Array.prototype.forEach.call(groups, function (group) {
      var radios = group.querySelectorAll('[role="radio"]');
      if (!radios.length) return;

      // Only correct groups the swatch app owns — leave any other radiogroup alone.
      var selected = group.querySelector('.swatch-selected[role="radio"]');
      if (!selected) return;

      Array.prototype.forEach.call(radios, function (radio) {
        var shouldBeChecked = radio === selected ? 'true' : 'false';
        if (radio.getAttribute('aria-checked') !== shouldBeChecked) {
          radio.setAttribute('aria-checked', shouldBeChecked);
        }
      });
    });
  }

  var scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      syncSwatchChecked(document);
    });
  }

  syncSwatchChecked(document);

  // The app rewrites these attributes after its own handlers run, so re-assert on change.
  // Watching class (selection) and aria-checked (the app's incorrect writes) is enough.
  var swatchObserver = new MutationObserver(scheduleSync);
  swatchObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-checked'],
  });

  // Swatches are re-rendered on variant/section changes too.
  $(document).on('shopify:section:load', scheduleSync);
});

// Variant swatch role correction (Swatch King / StarApps) — "grouped" cross-product
// swatches only.
//
// Some products use Swatch King in "grouped" mode: each colour swatch is actually a
// separate Shopify product, and activating a swatch navigates the browser to that
// product's page. Confirmed via the app's own click handler: it reads a `swatch-url`
// attribute on a descendant element and calls location.href/location.assign whenever
// that attribute is present and the swatch isn't flagged `current-product`.
//
// The app still renders these as role="radio" with aria-checked, which tells assistive
// tech "this changes a selection, you stay on this page" — activating one then
// unexpectedly navigates away, breaking that contract. The correct ARIA for "activating
// this goes to a different page, and this one represents where you already are" is
// role="link" plus aria-current — not radio/aria-checked (ARIA APG).
//
// Scoped narrowly: only swatch items with a [swatch-url] descendant are touched. Same-
// product variant swatches (no swatch-url — a plain in-page selection) are left as
// role="radio" for the aria-checked correction above to handle.
$(document).ready(function () {
  function isNavigatingSwatch(li) {
    return !!li.querySelector('[swatch-url]');
  }

  function correctSwatchLinks(root) {
    var radios = (root || document).querySelectorAll('li[role="radio"]');

    Array.prototype.forEach.call(radios, function (li) {
      if (!isNavigatingSwatch(li)) return;

      li.setAttribute('role', 'link');
      li.removeAttribute('aria-checked');

      // These were a single-tab-stop radiogroup (one reachable item, arrow keys move
      // between siblings). As a set of links to different pages, each needs its own tab
      // stop — the old roving -1/0 pattern would otherwise hide all but one from Tab.
      // Confirmed safe: the app's own activation listener is bound directly to
      // keydown/keyup (not gated on the role attribute), so this doesn't affect it.
      li.setAttribute('tabindex', '0');

      if (li.querySelector('[current-product]')) {
        li.setAttribute('aria-current', 'page');
      } else {
        li.removeAttribute('aria-current');
      }
    });
  }

  var scheduled = false;
  function scheduleCorrection() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      correctSwatchLinks(document);
    });
  }

  correctSwatchLinks(document);

  var swatchLinkObserver = new MutationObserver(scheduleCorrection);
  swatchLinkObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['role', 'aria-checked', 'current-product'],
  });

  $(document).on('shopify:section:load', scheduleCorrection);
});

// 360° product viewer (Empire Render <product-viewer> web component) — unlabelled
// rotation-frame images.
//
// This custom element renders every rotation frame as a real <img> inside its own shadow
// root (confirmed open-mode: this.attachShadow({mode: "open"}) in the vendor bundle), and
// never sets alt on those frames anywhere in its code — a screen reader announces each one
// as a nameless image, and a full rotation set can be dozens of frames. The individual
// frames carry no distinct information (same object, different angle), so they're set to
// alt="" here; the meaningful description is set directly in Liquid as role="group" +
// aria-label on the <product-viewer> element itself (product-media.liquid).
//
// Shadow DOM is invisible to a document-level MutationObserver, so each viewer's shadow
// root needs its own observer. The element is loaded via a deferred module script and may
// not have upgraded (attached its shadow root) yet when this runs, hence the retry loop.
$(document).ready(function () {
  var watched = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function stripFrameAlts(root) {
    var frames = root.querySelectorAll('img:not([alt])');
    Array.prototype.forEach.call(frames, function (img) {
      img.setAttribute('alt', '');
    });
  }

  function watch(viewerEl) {
    if (!viewerEl.shadowRoot) return false;
    if (watched && watched.has(viewerEl)) return true;
    if (watched) watched.add(viewerEl);

    stripFrameAlts(viewerEl.shadowRoot);

    new MutationObserver(function () {
      stripFrameAlts(viewerEl.shadowRoot);
    }).observe(viewerEl.shadowRoot, { childList: true, subtree: true });

    return true;
  }

  function scan() {
    var pending = false;
    document.querySelectorAll('product-viewer').forEach(function (el) {
      if (!watch(el)) pending = true;
    });
    return pending;
  }

  // Poll briefly for the custom element to upgrade (attach its shadow root); stop once
  // every instance found is being watched, or after ~10s if the element never appears.
  var attempts = 0;
  var poll = setInterval(function () {
    attempts++;
    if (!scan() || attempts > 20) clearInterval(poll);
  }, 500);
});

// Sitemap app-proxy page (/a/sitemap-tools/sitemap) — unlabelled "View more" links.
//
// This page's entire body is rendered by a third-party sitemap app via Shopify's app
// proxy, not by the theme (confirmed: the "djp-" class prefix appears nowhere in theme
// source). Each of the four sections (Products/Collections/Pages/Blog) ends in a
// "View more" link with no accessible context — a screen reader announces four
// identical, ambiguous "View more" links with nothing distinguishing them.
//
// Fully server-rendered (present in the initial HTML, not injected by JS), so no
// MutationObserver is needed here — just a one-time labelling pass. Reads the section's
// own visible heading (e.g. "Products") rather than parsing the destination URL, since
// one section's URL slug ("homepage") doesn't match its heading ("Blog").
$(document).ready(function () {
  if (!/\/a\/sitemap-tools\/sitemap/.test(window.location.pathname)) return;

  var buttons = document.querySelectorAll('a.djp-button:not([aria-label])');
  Array.prototype.forEach.call(buttons, function (btn) {
    var container = btn.closest('.djp-row') || btn.parentElement;
    var heading = container && container.querySelector('h1, h2, h3, h4, h5, h6');
    var section = heading ? heading.textContent.trim() : 'items';
    btn.setAttribute('aria-label', 'View more ' + section);
  });
});

// Policy pages (Terms of Service, Privacy Policy, Refund Policy, ...) — plain-text email
// addresses with no mailto: link.
//
// Policy body content comes from Shopify's native policy settings (merchant-edited in
// Admin → Settings → Policies), rendered as raw text/HTML into `.shopify-policy__body` —
// not theme markup, so there's no template to add a real <a> to at the source. Confirmed
// the same gap exists on multiple policies, not just one: Terms of Service
// ("admin@houseofleon.co"), Privacy Policy ("hello@houseofleon.co"), and Refund Policy
// (which already has ONE correct mailto: link plus 3 more plain-text repeats of the same
// address — merchant fixed one occurrence by hand and missed the rest).
//
// Fixed generally rather than as a one-off string replacement, since the policy text can
// change at any time in Admin: walks the text nodes inside .shopify-policy__body, finds
// anything email-shaped, and wraps it in a real mailto: link. Skips text already inside an
// <a> so the existing correct link on the Refund Policy isn't double-wrapped.
$(document).ready(function () {
  var body = document.querySelector('.shopify-policy__body');
  if (!body) return;

  var EMAIL_RE = /[\w.+-]+@[\w-]+\.[\w.-]*[a-zA-Z]/g;
  // Separate non-global instance for the plain yes/no check below. Reusing EMAIL_RE
  // (which has the g flag) for .test() would advance its lastIndex on every match,
  // causing later text nodes to be silently skipped once the cursor runs past their length.
  var EMAIL_TEST_RE = /[\w.+-]+@[\w-]+\.[\w.-]*[a-zA-Z]/;

  var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, {
    acceptNode: function (node) {
      if (node.parentElement && node.parentElement.closest('a')) {
        return NodeFilter.FILTER_REJECT;
      }
      return EMAIL_TEST_RE.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    },
  });

  var toProcess = [];
  var current;
  while ((current = walker.nextNode())) {
    toProcess.push(current);
  }

  toProcess.forEach(function (textNode) {
    var text = textNode.nodeValue;
    EMAIL_RE.lastIndex = 0;

    var fragment = document.createDocumentFragment();
    var lastIndex = 0;
    var match;

    while ((match = EMAIL_RE.exec(text))) {
      // Trim a bare trailing "." — almost always end-of-sentence punctuation, not part
      // of the domain (e.g. "...contact us at admin@houseofleon.co.").
      var email = match[0].replace(/\.+$/, '');

      fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));

      var link = document.createElement('a');
      link.href = 'mailto:' + email;
      link.textContent = email;
      fragment.appendChild(link);

      lastIndex = match.index + email.length;
    }

    fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
    textNode.parentNode.replaceChild(fragment, textNode);
  });
});

// Product accordion (Description/Dimensions/Specifications/Tear Sheet) — aria-expanded
// sync and focus management.
//
// The theme's own accordion class (GlobalAccordions in theme.js) toggles an "open" CSS
// class and slides the panel, but never touches aria-expanded — it is a static value
// baked into the Liquid template and never updates, so it always announces "collapsed"
// after the first toggle regardless of actual state. Separately, the theme's keyup-based
// focus helper only moves focus into a panel when that panel contains a link or input
// (`container.querySelector('a, input')`); the Description/Dimensions/Specifications
// panels are plain text, so that check fails silently and focus is left on the button
// after every activation.
$(document).ready(function () {
  function initAccordionA11y() {
    var toggles = document.querySelectorAll('[data-accordion-toggle]:not([data-a11y-bound])');
    if (!toggles.length) return;

    var FOCUSABLE = [
      'a[href]', 'button:not([disabled])', 'input:not([disabled])',
      'select:not([disabled])', 'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    function focusableIn(panel) {
      return Array.prototype.filter.call(
        panel.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
    }

    Array.prototype.forEach.call(toggles, function (toggle) {
      toggle.setAttribute('data-a11y-bound', 'true');

      // Correct the initial value for any panel the theme opens by default
      // (data-accordion-expand="true" on the first block).
      toggle.setAttribute('aria-expanded', toggle.classList.contains('open') ? 'true' : 'false');

      toggle.addEventListener('click', function () {
        var panel = toggle.parentElement.querySelector('[data-accordion-body]');
        if (!panel) return;

        // Deferred to a macrotask so this always runs after the theme's own click
        // handler has finished toggling the "open" class — independent of which
        // listener happens to be registered first.
        setTimeout(function () {
          var isOpen = toggle.classList.contains('open');
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

          if (isOpen) {
            window.requestAnimationFrame(function () {
              var items = focusableIn(panel);
              (items.length ? items[0] : panel).focus();
            });
          } else if (panel.contains(document.activeElement)) {
            // Closing while focus was left inside — don't strand it in hidden content.
            toggle.focus();
          }
        }, 0);
      });
    });
  }

  // Deferred once so the theme's own accordion init (which runs on the same
  // ready/section-load cycle) has already applied any default-open state.
  setTimeout(initAccordionA11y, 0);
  $(document).on('shopify:section:load', function () {
    setTimeout(initAccordionA11y, 0);
  });
});

// "Copy link" share button — announce success to screen readers.
//
// The theme's CopyClipboard handler (theme.js) copies the URL and shows a purely
// visual tooltip, gated to windowWidth > 749 — nothing is announced to assistive tech
// on any viewport. A static "Copied!" span used to sit in the link markup but was never
// toggled or referenced by any script. Delegated on document so it covers every
// [data-copy-clipboard] element without depending on load order or re-render timing.
$(document).ready(function () {
  var liveRegion = document.getElementById('a11y-copy-announcer');
  if (!liveRegion) {
    liveRegion = document.createElement('div');
    liveRegion.id = 'a11y-copy-announcer';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.className = 'visually-hidden';
    document.body.appendChild(liveRegion);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-copy-clipboard]');
    if (!trigger) return;

    // Clear first so a repeat copy (identical text) still re-triggers the announcement —
    // some screen readers only announce a live region when its content actually changes.
    liveRegion.textContent = '';
    window.requestAnimationFrame(function () {
      liveRegion.textContent = 'Link copied to clipboard';
    });
  });
});

// Screen reader / keyboard focus-tracking disconnect — unconditional smooth scrolling.
//
// `html { scroll-behavior: smooth }` is set sitewide (assets/theme.aio.min.css), with no
// prefers-reduced-motion guard anywhere in the CSS. Every focus-triggered scroll — the
// skip-to-content link, Tab-reachable in-page anchors — becomes an ANIMATED scroll instead
// of an instant one. A screen reader announces newly-focused content immediately; the
// visual scroll then takes ~300-500ms to catch up. On a long single-page document like
// this Terms of Service page, successive focus moves (e.g. activating the skip link, then
// tabbing on) queue overlapping scroll animations, and the visible page position falls out
// of sync with what's being announced — the reported disconnect.
//
// Two-part fix:
// 1. Respect prefers-reduced-motion — the standard baseline the CSS was missing entirely.
// 2. Disable smooth scrolling once keyboard use is detected. The population actually
//    affected here navigates via keyboard/AT, not mouse; an instant scroll keeps visual
//    position and announced content always in sync. Mouse-only users (unaffected by this
//    issue) keep the smooth animation on anchor-link clicks.
$(document).ready(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    document.documentElement.style.scrollBehavior = 'auto';
    return;
  }

  function disableSmoothScrollForKeyboard(e) {
    if (e.key !== 'Tab') return;
    document.documentElement.style.scrollBehavior = 'auto';
    document.removeEventListener('keydown', disableSmoothScrollForKeyboard);
  }

  document.addEventListener('keydown', disableSmoothScrollForKeyboard);
});

// Back to top button — show only after the user has scrolled down, and stay clear of
// other fixed bottom bars this theme already has.
//
// The button itself (sections/footer.liquid) was already built with a correct real
// <a href="#backtoheader"> + aria-label — it just needed visibility logic, since it was
// permanently hidden and never wired up. Scrolling and focus on activation are both
// handled natively (real anchor-jump to a real, already-focusable skip-link element) —
// this only toggles the `hidden` attribute based on scroll position.
//
// Two existing full-width fixed bars can occupy the same bottom strip of the viewport:
//   - .cart-bar (product pages, sticky Add to Cart bar, 80px tall, toggled via its own
//     .is-visible class on scroll)
//   - .article__social (blog articles, mobile only, switches to position:fixed via CSS
//     at the same 749px breakpoint the theme uses elsewhere)
// Both span the full viewport width, so left/right placement doesn't avoid them — only
// vertical clearance (cart-bar, known height) or hiding (article__social, unknown height,
// narrower use case) does.
$(document).ready(function () {
  var btn = document.getElementById('back-to-top');
  if (!btn) return;

  var SHOW_AFTER_PX = 400;
  var cartBar = document.querySelector('.cart-bar');
  var articleSocial = document.querySelector('.article__social');
  var ticking = false;

  function updateVisibility() {
    ticking = false;

    var scrolledEnough = window.scrollY > SHOW_AFTER_PX;
    var articleSocialActive = !!(articleSocial && getComputedStyle(articleSocial).position === 'fixed');

    btn.hidden = !scrolledEnough || articleSocialActive;

    var cartBarVisible = !!(cartBar && cartBar.classList.contains('is-visible'));
    btn.classList.toggle('back-to-top--raised', cartBarVisible);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateVisibility);
  }

  updateVisibility();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
});

// Focusable content trapped inside aria-hidden containers (PowerMapper finding).
//
// Root cause is in Flickity itself (assets/vendor.js, Cell.create/select/unselect): every
// non-active slide in ANY Flickity carousel gets aria-hidden="true" unconditionally, but
// Flickity never touches tabindex on that slide's own content. A keyboard user can Tab
// into a hidden, off-screen slide's link/button with no visual indication of where focus
// went — confirmed no tabindex handling exists anywhere near Flickity's select/unselect
// methods. This affects every Flickity carousel on the site (~28 sections/snippets use
// one — homepage slideshow, product galleries, "You may also like", etc.), not just the
// one screenshotted instance, so it's fixed generically here rather than only for that
// one carousel — vendor.js itself is intentionally left untouched (~28 use sites make
// hand-editing a large third-party bundle too large a blast radius to safely verify).
//
// Generic by design: ANY element with aria-hidden="true" containing focusable descendants
// is the same violation regardless of what put the attribute there, so this corrects the
// pattern sitewide, not just for Flickity specifically.
$(document).ready(function () {
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]';
  var SAVED_ATTR = 'data-a11y-saved-tabindex';

  function neutralize(container) {
    var items = container.querySelectorAll(FOCUSABLE);
    Array.prototype.forEach.call(items, function (el) {
      if (el.hasAttribute(SAVED_ATTR)) return; // already neutralized
      el.setAttribute(SAVED_ATTR, el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
      el.setAttribute('tabindex', '-1');
    });
  }

  function restore(container) {
    var items = container.querySelectorAll('[' + SAVED_ATTR + ']');
    Array.prototype.forEach.call(items, function (el) {
      var saved = el.getAttribute(SAVED_ATTR);
      if (saved) {
        el.setAttribute('tabindex', saved);
      } else {
        el.removeAttribute('tabindex');
      }
      el.removeAttribute(SAVED_ATTR);
    });
  }

  // Initial pass — Flickity marks non-active slides aria-hidden immediately on init,
  // before any user interaction, so this can't wait for the first attribute mutation.
  Array.prototype.forEach.call(document.querySelectorAll('[aria-hidden="true"]'), neutralize);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type !== 'attributes' || m.attributeName !== 'aria-hidden') return;
      if (m.target.getAttribute('aria-hidden') === 'true') {
        neutralize(m.target);
      } else {
        restore(m.target);
      }
    });
  }).observe(document.body, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
    subtree: true,
  });
});

